import { Box, Grid } from '@mui/material';

import MaxNewTokensField from './MaxNewTokensField';
import TemperatureField from './TemperatureField';
import TopPField from './TopPField';
import TypicalPField from './TypicalPField';

export interface AccountChatSettingsProps {
  max_new_tokens: number;
  setMaxNewTokens: (value: number) => void;
  temperature: number;
  setTemperature: (value: number) => void;
  top_p: number;
  setTopP: (value: number) => void;
  typical_p: number;
  setTypicalP: (value: number) => void;
  revision: number;
}

function AccountChatSettings({
  max_new_tokens,
  setMaxNewTokens,
  temperature,
  setTemperature,
  top_p,
  setTopP,
  typical_p,
  setTypicalP,
  revision,
}: AccountChatSettingsProps) {
  return (
    <Box width='100%' padding='15px'>
      <Grid container spacing={2}>
        <Grid size={12}>
          <Box
            padding='15px'
            sx={{
              maxWidth: 600,
            }}
          >
            <Grid container spacing={2}>
              <Grid size={12}>
                <MaxNewTokensField
                  key={`max_new_tokens_${revision}`}
                  value={max_new_tokens}
                  setValue={setMaxNewTokens}
                />
              </Grid>
              <Grid size={12}>
                <TemperatureField
                  key={`temperature_${revision}`}
                  value={temperature}
                  setValue={setTemperature}
                />
              </Grid>
              <Grid size={12}>
                <TopPField
                  key={`top_p_${revision}`}
                  value={top_p}
                  setValue={setTopP}
                />
              </Grid>
              <Grid size={12}>
                <TypicalPField
                  key={`typical_p_${revision}`}
                  value={typical_p}
                  setValue={setTypicalP}
                />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default AccountChatSettings;
